import { DonutPage } from "./DonutPage";

const Donut = () => {
	return <DonutPage />;
};
export default Donut;
